/** CSS (critical swim speed, m/s) -> pace per 100 m as "m:ss.s"; "not set" when unusable. */
export const cssToPacePer100 = css => {
    if (typeof css !== 'number' || !Number.isFinite(css) || css <= 0) return 'not set';
    const tenths = Math.round((100 / css) * 10); // round first so 59.96 s cannot print as "0:60.0"
    const minutes = Math.floor(tenths / 600);
    const seconds = (tenths - minutes * 600) / 10;
    return `${minutes}:${seconds.toFixed(1).padStart(4, '0')}`;
};

/** Metres -> km with one decimal; null/undefined volume counts as 0. */
export const formatKm = metres => ((Number(metres) || 0) / 1000).toFixed(1);
